import { render, staticRenderFns } from "./AppDescription.vue?vue&type=template&id=367f354a"
import script from "./AppDescription.vue?vue&type=script&lang=js"
export * from "./AppDescription.vue?vue&type=script&lang=js"
import style0 from "./AppDescription.vue?vue&type=style&index=0&id=367f354a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports